import React from "react";
import './BannerSupport.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function BannerSupport(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="BannerSupport">
            <div className="BannerSupportRight">
                <div className="BannerSupportTitle">
                    <TextSource ArrIndex= 'index0075'>Trade-Friendly and</TextSource>
                    <br/>
                    <TextSource ArrIndex= 'index0080'>Supportive Environment</TextSource>
                </div>
                <div className="BannerSupportText">
                    <ul>
                        <li><TextSource ArrIndex= 'index0085'>FREE FOREX TUTORIAL VIDEOS</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0090'>TIMELY ECONOMIC CALENDAR</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0095'>RESPONSIVE 24/5 ONLINE SUPPORT</TextSource> </li>
                    </ul>
                    <div className="BannerSupportButton ButtonOut">
                        <ChangeLink to={'/account/open'} lang={props.lang} style={{textDecoration: 'none'}}>
                            <div className='ButtonYellow'>
                                <TextSource ArrIndex= 'index0100'>START TRADING RIGHT AWAY</TextSource>
                            </div>
                        </ChangeLink>
                    </div>
                </div>

            </div>
            </div>
    )}

export default BannerSupport





